import compact from 'lodash/fp/compact'

const artistSubtitle = (...params: (string | undefined)[] ) => compact(params).join(' | ')

export default artistSubtitle
